import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "./Introduction.messages";
import styles from "./Introduction.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { nl2p } from "@src/utils/nl2p";

interface Introductions {
  title: string;
}

export const Introduction: React.FC<Introductions> = () => {
  const { formatMessage } = useIntl();

  return (
    <SimpleLayoutView>
      <div className={styles.introduction}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G6_P1_S1_Title)}</h3>
                {nl2p(formatMessage(messages.G6_P1_S1_Description))}
              </div>,

              <div key={2} className={styles.carouselItem}>
                <h3 className={styles.title}>{formatMessage(messages.G6_P1_S2_Title)}</h3>
                <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.G6_P1_S2_Description) }}></p>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
